import { CHECKOUT_STEPS, CheckoutStep } from '../types';

export const DEFAULT_CHECKOUT_STEP: CheckoutStep = 'works';

export const STEPPER_STEPS: { labelKey: string; step: CheckoutStep }[] = [
  { labelKey: 'orderReview.steps.selectWork', step: 'works' },
  { labelKey: 'orderReview.steps.placeBid', step: 'bid' },
  { labelKey: 'orderReview.steps.addDetails', step: 'details' },
  { labelKey: 'orderReview.steps.review', step: 'review' },
];

const ENTRY_STEPS = CHECKOUT_STEPS.filter((step) => {
  return step !== 'bid';
});

export const checkoutSteps = (isAuction: boolean): readonly CheckoutStep[] => {
  return isAuction ? CHECKOUT_STEPS : ENTRY_STEPS;
};

export const isCheckoutStep = (
  value: unknown,
  steps: readonly CheckoutStep[] = CHECKOUT_STEPS,
): value is CheckoutStep => {
  return typeof value === 'string' && steps.includes(value as CheckoutStep);
};
